import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "log-filters-compact" }
const _hoisted_2 = { class: "d-flex gap-1 flex-wrap" }
const _hoisted_3 = { class: "dropdown" }
const _hoisted_4 = { class: "dropdown-menu" }
const _hoisted_5 = ["onClick"]

import { computed, ref, onMounted } from "vue";
import dayjs from "dayjs";


export default {
  __name: 'BookingDateFilters',
  props: {
	dateRange: {
		type: Object,
		default: () => ({ from: null, until: null }),
	},
},
  emits: ["update:dateRange"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedFilter = ref(null);

// Generate available months (±6 months from current)
const availableMonths = computed(() => {
	const months = [];

	// Add past 6 months + current + next 6 months (13 total)
	for (let i = -6; i <= 6; i++) {
		const month = dayjs().add(i, "month");
		months.push({
			value: month.format("YYYY-MM"),
			label: month.format("MMMM YYYY"),
		});
	}

	return months;
});

const selectedMonthLabel = computed(() => {
	if (
		selectedFilter.value === "month" &&
		props.dateRange.from &&
		props.dateRange.until
	) {
		const fromMonth = dayjs(props.dateRange.from);
		return fromMonth.format("MMMM YYYY");
	}
	return "Monat wählen";
});

const setQuickRange = (type) => {
	selectedFilter.value = type;
	let from, until;

	switch (type) {
		case "today":
			from = dayjs().format("YYYY-MM-DD");
			until = dayjs().format("YYYY-MM-DD");
			break;
		case "next14days":
			from = dayjs().format("YYYY-MM-DD");
			until = dayjs().add(14, "days").format("YYYY-MM-DD");
			break;
		default:
			from = null;
			until = null;
	}

	emit("update:dateRange", { from, until });
};

const setMonthRange = (monthValue) => {
	selectedFilter.value = "month";
	const from = dayjs(monthValue).startOf("month").format("YYYY-MM-DD");
	const until = dayjs(monthValue).endOf("month").format("YYYY-MM-DD");

	emit("update:dateRange", { from, until });

	// Force close dropdown by triggering a re-render
	setTimeout(() => {
		const dropdownElement = document.querySelector(
			'.dropdown-toggle[aria-expanded="true"]'
		);
		if (dropdownElement) {
			dropdownElement.click();
		}
	}, 100);
};

// Set default selection on mount and detect existing date range
onMounted(() => {
	const today = dayjs().format("YYYY-MM-DD");

	// Check if the current dateRange matches today
	if (props.dateRange.from === today && props.dateRange.until === today) {
		selectedFilter.value = "today";
	}
	// Check if it matches next 14 days
	else if (
		props.dateRange.from === today &&
		props.dateRange.until === dayjs().add(14, "days").format("YYYY-MM-DD")
	) {
		selectedFilter.value = "next14days";
	}
	// Check if it matches a full month
	else if (props.dateRange.from && props.dateRange.until) {
		const fromMonth = dayjs(props.dateRange.from);
		const expectedFrom = fromMonth.startOf("month").format("YYYY-MM-DD");
		const expectedUntil = fromMonth.endOf("month").format("YYYY-MM-DD");

		if (
			props.dateRange.from === expectedFrom &&
			props.dateRange.until === expectedUntil
		) {
			selectedFilter.value = "month";
		}
	}
	// Default to today if no range is set
	else if (!props.dateRange.from && !props.dateRange.until) {
		selectedFilter.value = "today";
	}
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass([
          'btn btn-sm',
          selectedFilter.value === 'today' ? 'btn-primary' : 'btn-outline-secondary',
        ]),
        onClick: _cache[0] || (_cache[0] = $event => (setQuickRange('today')))
      }, " Heute ", 2 /* CLASS */),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass([
          'btn btn-sm',
          selectedFilter.value === 'next14days'
            ? 'btn-primary'
            : 'btn-outline-secondary',
        ]),
        onClick: _cache[1] || (_cache[1] = $event => (setQuickRange('next14days')))
      }, " 14 Tage ", 2 /* CLASS */),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass([
            'btn btn-sm dropdown-toggle',
            selectedFilter.value === 'month'
              ? 'btn-primary'
              : 'btn-outline-secondary',
          ]),
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false"
        }, _toDisplayString(selectedMonthLabel.value), 3 /* TEXT, CLASS */),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableMonths.value, (month) => {
            return (_openBlock(), _createElementBlock("li", {
              key: month.value
            }, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _withModifiers($event => (setMonthRange(month.value)), ["prevent"])
              }, _toDisplayString(month.label), 9 /* TEXT, PROPS */, _hoisted_5)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}
}

}